'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _coreDecorators = require('core-decorators');

var _styling = require('@rexlabs/styling');

var _cssAnimationGroup = require('@rexlabs/css-animation-group');

var _cssAnimationGroup2 = _interopRequireDefault(_cssAnimationGroup);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_EASING = 'cubic-bezier(0.25, 1, 0.25, 1)';
var DEFAULT_HEIGHT = 250;

var fadeIn = (0, _styling.keyframes)({
  '0%': { opacity: 0 },
  '100%': { opacity: 1 }
});

var fadeOut = (0, _styling.keyframes)({
  '0%': { opacity: 1 },
  '100%': { opacity: 0 }
});

var animate = function animate(_ref) {
  var animation = _ref.animation,
      duration = _ref.duration,
      easing = _ref.easing,
      delay = _ref.delay,
      iterations = _ref.iterations,
      direction = _ref.direction,
      fillMode = _ref.fillMode;

  return animation + ' ' + (0, _utils.normalizeTime)(duration) + ' ' + easing + ' ' + (0, _utils.normalizeTime)(delay) + ' ' + iterations + ' ' + direction + ' ' + fillMode;
};

var defaultStyles = (0, _styling.StyleSheet)({
  topLevelContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },

  topLevelContainerCentered: {
    alignItems: 'center',
    justifyContent: 'center'
  },

  animationContainer: {
    width: '100%'
  },

  container: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  },

  wrapLoadingView: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    maxHeight: '60vh'
  },

  listContainer: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    transform: 'translate3d(0, 0, 0)'
  },

  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: '0'
  }
});

var RenderLoading = (_dec = (0, _styling.styled)(defaultStyles), _dec(_class = (0, _coreDecorators.autobind)(_class = (_temp = _class2 = function (_React$PureComponent) {
  (0, _inherits3.default)(RenderLoading, _React$PureComponent);

  function RenderLoading(props) {
    (0, _classCallCheck3.default)(this, RenderLoading);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RenderLoading.__proto__ || (0, _getPrototypeOf2.default)(RenderLoading)).call(this, props));

    _this.state = {
      isLoading: props.isLoading,
      loadingChanged: !props.isLoading,
      height: props.minHeight,
      loadingHeight: props.minHeight
    };

    _this.throttleLoadingTimeout = null;
    return _this;
  }

  (0, _createClass3.default)(RenderLoading, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        return _this2.setState({
          height: _this2._content ? _this2._content.offsetHeight : _this2.props.minHeight
        });
      }, 0);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.throttleLoadingTimeout);
      this.throttleLoadingTimeout = null;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      // Add a slight threshold to prevent RenderLoading from rapidly
      // switching between loading states.

      // NOTE: Technically this introduces artifical lag, just FYI.
      if (this.props.isLoading === true && nextProps.isLoading === false) {
        this.throttleLoadingTimeout = setTimeout(function () {
          _this3.setState({
            isLoading: false,
            loadingChanged: true,
            height: _this3._content ? _this3._content.offsetHeight : _this3.state.height
          });
        }, nextProps.switchingThreshold);
      } else if (this.props.isLoading === false && nextProps.isLoading === true) {
        clearTimeout(this.throttleLoadingTimeout);
        this.setState({
          isLoading: true,
          loadingChanged: true,
          height: this._content ? this._content.offsetHeight : this.state.height,
          loadingHeight: this._content ? this._content.offsetHeight : this.state.height
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this._content) {
        this.setState({
          height: this._content.offsetHeight
        });
      }
    }
  }, {
    key: 'getLoadingOrError',
    value: function getLoadingOrError() {
      var _props = this.props,
          s = _props.styles,
          loadErrors = _props.loadErrors,
          LoadingView = _props.LoadingView,
          ErrorView = _props.ErrorView;
      var _state = this.state,
          isLoading = _state.isLoading,
          loadingHeight = _state.loadingHeight;


      var errorElement = _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, s('container'), { key: 'error' }),
        _react2.default.createElement(ErrorView, { errors: loadErrors })
      );

      var loadingElement = _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, s('container'), { key: 'loading' }),
        _react2.default.createElement('div', s('loading')),
        _react2.default.createElement(
          'div',
          (0, _extends3.default)({}, s('wrapLoadingView'), { style: { height: loadingHeight } }),
          _react2.default.createElement(LoadingView, null)
        )
      );

      if (loadErrors && loadErrors.length) {
        return errorElement;
      }

      if (isLoading) {
        return loadingElement;
      }

      return null;
    }
  }, {
    key: 'setRef',
    value: function setRef(ref) {
      this._content = ref;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          s = _props2.styles,
          children = _props2.children,
          loadErrors = _props2.loadErrors,
          alwaysRenderChildren = _props2.alwaysRenderChildren,
          ContentAfter = _props2.ContentAfter,
          _props2$animationConf = _props2.animationConfig,
          component = _props2$animationConf.component,
          enterAnimation = _props2$animationConf.enterAnimation,
          enterDelay = _props2$animationConf.enterDelay,
          enterDirection = _props2$animationConf.enterDirection,
          enterDuration = _props2$animationConf.enterDuration,
          enterFillMode = _props2$animationConf.enterFillMode,
          enterIterationCount = _props2$animationConf.enterIterationCount,
          enterTimingFunction = _props2$animationConf.enterTimingFunction,
          leaveAnimation = _props2$animationConf.leaveAnimation,
          leaveDelay = _props2$animationConf.leaveDelay,
          leaveDirection = _props2$animationConf.leaveDirection,
          leaveDuration = _props2$animationConf.leaveDuration,
          leaveFillMode = _props2$animationConf.leaveFillMode,
          leaveIterationCount = _props2$animationConf.leaveIterationCount,
          leaveTimingFunction = _props2$animationConf.leaveTimingFunction,
          enterOnAppear = _props2$animationConf.enterOnAppear;
      var _state2 = this.state,
          isLoading = _state2.isLoading,
          loadingChanged = _state2.loadingChanged,
          height = _state2.height;


      var content = _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, s('content'), {
          key: 'content',
          ref: this.setRef,
          style: (0, _extends3.default)({}, loadingChanged && alwaysRenderChildren ? !isLoading && loadErrors && !loadErrors.length ? {
            animation: animate({
              animation: enterAnimation,
              duration: enterDuration,
              easing: enterTimingFunction,
              delay: enterDelay,
              iterations: enterIterationCount,
              direction: enterDirection,
              fillMode: enterFillMode
            })
          } : {
            animation: animate({
              animation: leaveAnimation,
              duration: leaveDuration,
              easing: leaveTimingFunction,
              delay: leaveDelay,
              iterations: leaveIterationCount,
              direction: leaveDirection,
              fillMode: leaveFillMode
            })
          } : {
            opacity: 1
          })
        }),
        children
      );

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, s('topLevelContainer', {
          topLevelContainerCentered: this.getLoadingOrError()
        }), {
          // NOTE by Julian: changed this to use "auto" height when loaded, cause we constantly
          // run into issues where the height changes after load has been completed but render
          // loading will keep the old wrong height .. we don't really run into the issue the fixed
          // height is supposed to solve (content jumping when re-entering loading state e.g.)
          style: { height: this.getLoadingOrError() ? height : 'auto' }
        }),
        _react2.default.createElement(
          _cssAnimationGroup2.default,
          (0, _extends3.default)({}, s('animationContainer'), {
            component: component,
            enterAnimation: enterAnimation,
            enterDelay: enterDelay,
            enterDirection: enterDirection,
            enterDuration: enterDuration,
            enterFillMode: enterFillMode,
            enterIterationCount: enterIterationCount,
            enterTimingFunction: enterTimingFunction,
            leaveAnimation: leaveAnimation,
            leaveDelay: leaveDelay,
            leaveDirection: leaveDirection,
            leaveDuration: leaveDuration,
            leaveFillMode: leaveFillMode,
            leaveIterationCount: leaveIterationCount,
            leaveTimingFunction: leaveTimingFunction,
            enterOnAppear: enterOnAppear
          }),
          alwaysRenderChildren && content,
          this.getLoadingOrError() || !alwaysRenderChildren && content,
          ContentAfter
        )
      );
    }
  }]);
  return RenderLoading;
}(_react2.default.PureComponent), _class2.displayName = 'RenderLoading', _class2.defaultProps = {
  switchingThreshold: 50,
  alwaysRenderChildren: true,
  loadErrors: [],
  minHeight: DEFAULT_HEIGHT,
  ContentAfter: null,
  animationConfig: {
    component: 'div',
    enterAnimation: fadeIn,
    enterDelay: 0,
    enterDirection: 'normal',
    enterDuration: 180,
    enterFillMode: 'forwards',
    enterIterationCount: 1,
    enterTimingFunction: DEFAULT_EASING,
    leaveAnimation: fadeOut,
    leaveDelay: 0,
    leaveDirection: 'normal',
    leaveDuration: 180,
    leaveFillMode: 'forwards',
    leaveIterationCount: 1,
    leaveTimingFunction: DEFAULT_EASING,
    enterOnAppear: false
  },
  LoadingView: function LoadingView() {
    return _react2.default.createElement(
      'div',
      null,
      'Loading...'
    );
  },
  ErrorView: function ErrorView(_ref2) {
    var errors = _ref2.errors;
    return _react2.default.createElement(
      'div',
      null,
      errors.map(function (message, i) {
        return _react2.default.createElement(
          'span',
          { key: i },
          message
        );
      })
    );
  }
}, _temp)) || _class) || _class);
process.env.NODE_ENV !== "production" ? RenderLoading.propTypes = {
  isLoading: _propTypes2.default.bool.isRequired,
  loadErrors: _propTypes2.default.array,
  children: _propTypes2.default.node,
  switchingThreshold: _propTypes2.default.number,
  alwaysRenderChildren: _propTypes2.default.bool,
  LoadingView: _propTypes2.default.func,
  ErrorView: _propTypes2.default.func,
  minHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  ContentAfter: _propTypes2.default.element,
  animationConfig: _propTypes2.default.shape({
    component: _utils.componentType,
    enterAnimation: _propTypes2.default.string,
    enterDelay: _utils.timeType,
    enterDirection: _utils.directionType,
    enterDuration: _utils.timeType,
    enterFillMode: _utils.fillModeType,
    enterIterationCount: _propTypes2.default.number,
    enterTimingFunction: _propTypes2.default.string,
    leaveAnimation: _propTypes2.default.string,
    leaveDelay: _utils.timeType,
    leaveDirection: _utils.directionType,
    leaveDuration: _utils.timeType,
    leaveFillMode: _utils.fillModeType,
    leaveIterationCount: _propTypes2.default.number,
    leaveTimingFunction: _propTypes2.default.string,
    enterOnAppear: _propTypes2.default.bool
  })
} : void 0;
exports.default = RenderLoading;